import withLocalLoader from 'components/HOCs/withLocalLoader';
import { connect } from 'react-redux';
import OepUpdates from 'tailwind-components/OepUpdates/OepUpdates';
import { getAppointmentsViewData } from 'state/actions/actions';

export default connect(null, { getAppointmentsViewData })(
  withLocalLoader(OepUpdates, true, 'OEP Updates', 'OEP Updates')
);
